import { usePathname, useRouter, useSearchParams } from 'next/navigation'
import { FC } from 'react'

import { YandexMetrikaEvent } from '@/app/constants/metrics'
import {
  NotificationButton,
  NotificationDrawer
} from '@/components/entities/notification'
import { useYandexMetrika } from '@/components/shared/yandex-metrika/hooks/useYandexMetrika'
import {
  APP_DRAWER_QUERY_KEY,
  NOTIFICATION_DRAWER_QUERY_VALUE
} from '@/utils/constants'

const Notifications: FC = () => {
  const router = useRouter()
  const pathname = usePathname() || '/'
  const searchParams = useSearchParams()
  const { reachGoal } = useYandexMetrika()

  const isActive =
    searchParams?.get(APP_DRAWER_QUERY_KEY) ===
      NOTIFICATION_DRAWER_QUERY_VALUE || pathname.includes('/notifications')

  const closeDrawer = () => {
    const params = new URLSearchParams(searchParams?.toString())
    params.delete(APP_DRAWER_QUERY_KEY, NOTIFICATION_DRAWER_QUERY_VALUE)
    const queryString = params.toString()
    const url = queryString ? `${pathname}?${queryString}` : pathname

    router.push(url)
  }

  const onButtonClick = () => {
    const params = new URLSearchParams(searchParams?.toString())
    params.set(APP_DRAWER_QUERY_KEY, NOTIFICATION_DRAWER_QUERY_VALUE)
    router.push(`${pathname}?${params.toString()}`)
    reachGoal(YandexMetrikaEvent.MAIN_NOTIFICATIONS)
  }

  return (
    <>
      <NotificationButton active={isActive} onClick={onButtonClick} />

      <NotificationDrawer opened={isActive} onClose={closeDrawer} />
    </>
  )
}

export default Notifications
